export default () => {
    const trainersArea = $('#trainersArea');
    const mobileTrainers = $('#mobileTrainers');

    const alumniSwiper = new Swiper('.alumni-swiper', {
        loop: true,
        spaceBetween: 40,
        direction: 'horizontal',
        grabCursor: true,
        simulateTouch: true,
        preventClicks: true,
        keyboardControl: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        }
    });

    if (!trainersArea.hasClass('no-trainer')) {
        const trainerSwiper = new Swiper('#trainersArea', {
            slidesPerView: 4,
            spaceBetween: 40,
            direction: 'horizontal',
            grabCursor: true,
            simulateTouch: true,
            preventClicks: true,
            keyboardControl: true,
            paginationClickable: true,
            navigation: {
                nextEl: '.next-trainer',
                prevEl: '.prev-trainer',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            /*autoplay: {
              delay: 3500,
              disableOnInteraction: true,
            },*/
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                    spaceBetween: 16,
                    // navigation: false,
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                },
                2048: {
                    spaceBetween: 40,
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                },
            },
        });
    }

    if (mobileTrainers.length) {
        const trainerSwiperMobile = new Swiper('#mobileTrainers', {
            slidesPerView: 4,
            spaceBetween: 40,
            direction: 'horizontal',
            grabCursor: true,
            simulateTouch: true,
            preventClicks: true,
            keyboardControl: true,
            paginationClickable: true,
            navigation: {
                nextEl: '.next-trainer-mobile',
                prevEl: '.prev-trainer-mobile',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                    spaceBetween: 16,
                    // navigation: false,
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: 1,
                    grid: {
                        rows: 2,
                    },
                },
            },
        });
    }


};
